<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">LTA</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-3">
          <txt label="From" name="from" v-model="journy.from" />
        </div>
        <div class="col-3">
          <txt label="To" name="to" v-model="journy.to" />
        </div>
        <div class="col-3">
          <tl-select
            label="Mode of Travel"
            :options="['Flight', 'Train']"
            v-model="journy.mode_of_travel"
            @change="(val) => journy.mode_of_travel=val"
          ></tl-select>
        </div>
        <div class="col-3">
          <txt
            type="number"
            label="Total Distance ( in km)"
            name="distance"
            v-model="journy.distance"
          />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Journy" type="secondary" @click="addMoreJourny()" />
        </div>
      </div>
      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="journyList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @deleteByIndex="deleteJourny($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key != 'srNo'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            </div>
          </template>
        </data-table>
      </div>
      <tl-header type="h1" class="margin-t-l">
        <div class="d_heading">Cost incurred by Dependent on travel</div>
      </tl-header>
      <div class="row margin-t-m">
        <div class="col-3">
          <tl-select
            label="Name"
            :options="['John Snow', 'Arya']"
            v-model="dependent.name"
            @change="(val) => dependent.name=val"
          ></tl-select>
        </div>
        <div class="col-3">
          <txt label="Relation" name="relation" v-model="dependent.relation" />
        </div>
        <div class="col-2">
          <txt type="number" label="Age" name="age" v-model="dependent.age" />
        </div>
        <div class="col-2">
          <txt label="Marital Status" name="marital_status" v-model="dependent.marital_status" />
        </div>
        <div class="col-2">
          <txt type="number" label="Amount" name="amount" v-model="dependent.amount" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Dependent" type="secondary" @click="addMoreDependents()" />
        </div>
      </div>
      <div class="margin-t-l">
        <data-table
          :columns="dependentTableColumns"
          :tableData="dependentList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @deleteByIndex="deleteDependent($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key != 'srNo'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            </div>
          </template>
        </data-table>
      </div>
      <tl-header type="h1" class="margin-t-l">
        <div class="d_heading">Previous Year Exemption Details</div>
      </tl-header>
      <div class="margin-t-l">
        <data-table
          :columns="exemptionColumns"
          :tableData="exemptionList"
          :showinrow="false"
          :showhistory="false"
          :showedit="false"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'pre_year'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p v-if="slotprops.value.column.key == 'company'">
                <txt
                  :name="'company'+slotprops.value.index"
                  v-model="exemptionList[slotprops.value.index].company"
                />
              </p>
              <p v-if="slotprops.value.column.key == 'amount'">
                <txt
                  type="number"
                  :name="'amount'+slotprops.value.index"
                  v-model="exemptionList[slotprops.value.index].amount"
                />
              </p>
            </div>
          </template>
        </data-table>
        <div class="row margin-t-m">
          <div class="col-12">
            <div class="upload-heading">Upload the proof</div>
          </div>
          <div class="col-12 margin-t-s">
            <upload @change="(val)=>docUrl=val.data.location" />
          </div>
          <div class="col-12 margin-t-m">
            <btn text="Add Bill" type="secondary" @click="addMoreProof()" />
          </div>
        </div>
        <div class="margin-t-m">
          <data-table
            :columns="proofColumns"
            :tableData="proofList"
            :showinrow="true"
            :showhistory="false"
            :showedit="false"
            @delete="deleteItem($event)"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
                <p v-if="slotprops.value.column.key == 'proofs'">
                  <img src="@/assets/ic-attachment.png" alt />
                  {{slotprops.value.record[slotprops.value.column.key]}} attacment
                </p>
                <p
                  v-if="slotprops.value.column.key == 'upload_on'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      journy: {
        from: "",
        to: "",
        mode_of_trvel: "",
        distance: ""
      },
      dependent: {
        name: "",
        relation: "",
        age: "",
        marital_status: "",
        amount: 0
      },
      name: "",
      relation: "",
      age: "",
      marital_status: "",
      docUrl: "",
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "From",
          key: "from"
        },
        {
          label: "To",
          key: "to"
        },
        {
          label: "Mode of Travel",
          key: "mode_of_travel"
        },
        {
          label: "Total Distance (in Km)",
          key: "distance"
        }
      ],
      dependentTableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Relation",
          key: "relation"
        },
        {
          label: "Age",
          key: "age"
        },
        {
          label: "Marital Status",
          key: "marital_status"
        },
        {
          label: "Amount",
          key: "amount"
        }
      ],
      exemptionColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Previous Year",
          key: "pre_year"
        },
        {
          label: "Company",
          key: "company"
        },
        {
          label: "Amount",
          key: "amount"
        }
      ],
      proofColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Proofs",
          key: "proofs"
        },
        {
          label: "Uploaded on",
          key: "upload_on"
        }
      ],
      proofList: [],
      exemptionList: [],
      dependentList: [],
      journyList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      ltaData: state => state.LTA
    })
  },
  activated() {
    this.showSuccessMsg = false;
    this.prepExemptList();
    this.setLTA();
  },
  methods: {
    ...mapActions({
      saveData: "dashboard/organisation/utilities/itdeclarations/saveLTA"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        await this.saveData({
          id: this.$route.query.id,
          lta_data: {
            proofs: this.proofList.map(item => {
              return item.fileLocation;
            }),
            proofList: this.proofList,
            pre_year_exempt: this.exemptionList,
            dependent: this.dependentList,
            journy: this.journyList
          }
        });
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setLTA() {
      try {
        if (this.ltaData[this.$route.query.id]) {
          let obj = this.ltaData[this.$route.query.id].lta_data;
          this.journyList = obj.journy;
          this.exemptionList = obj.pre_year_exempt;
          this.dependentList = obj.dependent;
          this.proofList = obj.proofList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreJourny() {
      try {
        this.journyList.push(this.journy);
        this.journy = {
          from: "",
          to: "",
          mode_of_trvel: "",
          distance: ""
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreDependents() {
      try {
        this.dependentList.push(this.dependent);
        this.dependent = {
          name: "",
          relation: "",
          age: "",
          marital_status: "",
          amount: 0
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreProof() {
      try {
        let d = new Date();
        let value =
          d.getFullYear() +
          "-" +
          ("0" + (d.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + d.getDate()).slice(-2);
        this.proofList.push({
          proofs: 1,
          fileLocation: this.docUrl,
          upload_on: value
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    prepExemptList() {
      try {
        let d = new Date();
        let currentYear = d.getFullYear();
        let i = 0;
        this.exemptionList = [];
        while (i < 2) {
          this.exemptionList.push({
            pre_year: currentYear - (i + 1),
            company: "",
            amount: 0
          });
          i++;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteJourny(record) {
      try {
        this.journyList.splice(record.index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDependent(record) {
      try {
        this.dependentList.splice(record.index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
